import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const LogoBlue = (): React.JSX.Element => {
	return <AtlassianLogo appearance="brand" />;
};

export default LogoBlue;
